import { lazy, Suspense } from 'react';
import { ViewOptionsBar } from './ViewOptionsBar';
import { useDesktopLayoutStyles } from './styles';

const Create = lazy(() => import('@/components/Create'));
const PresetGallery = lazy(() => import('@/components/PresetGallery'));
const Generations = lazy(() => import('@/components/Generations'));

type ViewSize = 'small' | 'medium' | 'large';

interface DesktopLayoutProps {
  rightPanelTab: 'presets' | 'creations';
  setRightPanelTab: (tab: 'presets' | 'creations') => void;
  viewCrop: boolean;
  setViewCrop: (crop: boolean) => void;
  viewSize: ViewSize;
  setViewSize: (size: ViewSize) => void;
}

export const DesktopLayout = ({
  rightPanelTab,
  setRightPanelTab,
  viewCrop,
  setViewCrop,
  viewSize,
  setViewSize,
}: DesktopLayoutProps) => {
  const classes = useDesktopLayoutStyles();

  return (
    <div className={classes.desktopPanels}>
      <div className={classes.leftPanel}>
        <div className={classes.panelContent}>
          <Suspense fallback={null}>
            <Create />
          </Suspense>
        </div>
      </div>

      <div className={classes.rightPanel}>
        <ViewOptionsBar
          rightPanelTab={rightPanelTab}
          setRightPanelTab={setRightPanelTab}
          viewCrop={viewCrop}
          setViewCrop={setViewCrop}
          viewSize={viewSize}
          setViewSize={setViewSize}
        />

        <div className={classes.tabContent}>
          <Suspense fallback={null}>
            {rightPanelTab === 'presets' ? (
              <PresetGallery viewCrop={viewCrop} viewSize={viewSize} />
            ) : (
              <Generations viewCrop={viewCrop} viewSize={viewSize} />
            )}
          </Suspense>
        </div>
      </div>
    </div>
  );
};
